import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import otherManagementServices from '../otherManagementServices';
import { IUpdateCategoryArgs, IOtherManagementState } from '../types';
import { batch } from 'react-redux';
import { updateFiles } from '../helpers';
import { isArray } from 'lodash';
import { toastActions } from 'pages/_commons/Toast/_redux';
import { otherManagementActions } from '.';

export const saveCategory = createAsyncThunk<
  unknown,
  IUpdateCategoryArgs,
  ThunkAPIConfig
>('saveCategory', async (args, { dispatch, getState, rejectWithValue }) => {
  try {
    const { detail } = getState().other.category;
    dispatch(
      toastActions.addToast({
        show: true,
        message: '파일 업로드 중...',
        type: 'warning'
      })
    );
    const files = await updateFiles(detail?.file ? [detail.file] : [], [
      args.data.file
    ]);

    if (!isArray(files)) throw new Error();
    const params = {
      ...args.data,
      file: files[0]
    };

    await (args?.data?.id
      ? otherManagementServices.updateCategory(params)
      : otherManagementServices.addCategory(params));

    return batch(() => {
      dispatch(
        toastActions.addToast({
          show: true,
          message: '성공',
          type: 'success'
        })
      );
      dispatch(
        otherManagementActions.getCategories({
          limit: 5
        })
      );
      dispatch(otherManagementActions.setCategoryAction('list'));
      dispatch(otherManagementActions.setSelectedCategory());
    });
  } catch (error) {
    dispatch(
      toastActions.addToast({
        show: true,
        message: '오류',
        type: 'error'
      })
    );
    return rejectWithValue(error);
  }
});

export const saveCategoryBuilder = (
  builder: ActionReducerMapBuilder<IOtherManagementState>
) => {
  const { pending, fulfilled, rejected } = saveCategory;
  builder
    .addCase(pending, draftState => {
      draftState.category.loading = true;
    })
    .addCase(fulfilled, draftState => {
      draftState.category.loading = false;
    })
    .addCase(rejected, draftState => {
      draftState.category.loading = false;
    });
};
